import { Component, OnInit, Input } from '@angular/core';

// import { ChartType } from '../../saas.model';

@Component({
  selector: 'app-selling-chart',
  templateUrl: './selling-chart.component.html',
  styleUrls: ['./selling-chart.component.scss']
})
export class SellingChartComponent implements OnInit {

  @Input() Chartcolor;
  @Input() value;

  chartData: any ; //ChartType;

  constructor() { }

  ngOnInit(): void {
    this.chartData = {
      series: [this.value],
      chart: {
        type: 'radialBar',
        width: 60,
        height: 60,
        sparkline: {
          enabled: true
        }
      },
      dataLabels: {
        enabled: false
      },
      colors: [this.Chartcolor],
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 0,
            size: '60%'
          },
          track: {
            margin: 0
          },
          dataLabels: {
            show: false
          }
        }
      }
    };
  }
}
